export const OFFENSE_OPTIONS = [
  { name: "harassment", value: "report_harassment" },
  { name: "violent", value: "report_violent" },
  { name: "threat", value: "report_threat" },
];
